<template>
  <v-list-item @click="goTo()">
    <v-list-item-avatar>
      <v-icon>
        {{ icon }}
      </v-icon>
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title>{{ navigationItem.title }}</v-list-item-title>

      <v-list-item-subtitle>{{ navigationItem.description }}</v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script lang="ts">
import { NavigationRoute } from "@/store/mapper/navigation.route";
import { PartnerModule } from "@/store/modules/partner";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class NavigationListItem extends Vue {
  @Prop()
  navigationItem!: NavigationRoute;

  get icon() {
    return this.navigationItem?.navigation?.icon || "mdi-alert-circle-outline";
  }

  get partnerId() {
    return PartnerModule.partner._id;
  }

  goTo() {
    this.$router.push({ name: this.navigationItem.name, params: { partnerId: this.partnerId } });
  }
}
</script>
